import { useQuery } from "@apollo/client";
import { FETCH_AGENT_SESSION_IDS } from "_graphql/visal/queries/fetchAgentSessionIds";
import {
    FetchAgentSessionIds,
    FetchAgentSessionIds_fetchAgentSessionIds_session_ids,
    FetchAgentSessionIdsVariables,
} from "../../_graphql/visal/queries/__generated__/FetchAgentSessionIds";

const useSessions = (variables: FetchAgentSessionIdsVariables) => {
    const { data, refetch, loading } = useQuery<
        FetchAgentSessionIds,
        FetchAgentSessionIdsVariables
    >(FETCH_AGENT_SESSION_IDS, { variables });

    return {
        sessions: (data?.fetchAgentSessionIds?.session_ids ||
            []) as FetchAgentSessionIds_fetchAgentSessionIds_session_ids[],
        isLoading: loading,
        refetch,
    };
};

export default useSessions;
